import _ from "lodash";

//事件管理器
export function EventManager(){

    let _slots = {};

    const parseEvent = (event)=>{
        let pos = event.indexOf(".");
        if(pos<0) return {name:event,suffix:""}; //name:事件名称,suffix:后缀名
        const name = event.substring(0,pos);
        const suffix = event.substring(pos+1);
        return {name,suffix};
    }

    this.on = (event,handle)=>{ //event:事件名称
        const {name,suffix} = parseEvent(event);
        let slot = _slots[name];
        if(!slot) slot = _slots[name] = new Slot();
        slot.addHandle(suffix,handle);
    }

    this.off = (event,handle)=>{ //event:事件名称，可以带.  ，handle:可以不传
        const {name,suffix} = parseEvent(event);
        let slot = _slots[name];
        if(!slot) return;
        slot.removeHandle(suffix,handle);
    }

    const getHandles = (eventName)=>{   //得到事件名称对应的所有的handle
        let slot = _slots[eventName];
        if(!slot) return null;
        return slot.getHandles();
    }
    
    this.raise = function (eventName){   //event:是事件名称name
        let handles = getHandles(eventName);
        if(!handles) return;

        let args = [...arguments].slice(1);
        for(let i=0;i<handles.length;i++){
            const handle = handles[i];
            let r = handle.apply(null,args);
            if(r===false) return false;
        }
    }

    this.clear = ()=>{
        _slots = {};
    }

    this.is = (event,target)=>{
        return parseEvent(event).name===target;
    }
}

function Slot(){

    let _events=[];

    this.getHandles = ()=>{
        let l = _events;
        return l.map((e)=>e.handle);
    }

    this.addHandle = (suffix,handle)=>{
        _events.push({suffix,handle});
    }

    this.removeHandle = (suffix,handle)=>{
        if(handle){//注销指定handle的事件
            _.remove(_events,(e)=>e.suffix === suffix && e.handle ===handle);
            return;
        }
        _.remove(_events,(e)=>e.suffix === suffix);
    }

}

